import React from "react";
import {
  Box,
  Button,
  IconButton,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import default_theme from "assets/themes/themes";

const SolutionDetailActions = ({
  entry,
  isAuthenticated,
  favorites,
  toggleFavorite,
  handleBackClick,
  styles,
  backLabel = "Back to Catalogue",
}) => {
  return (
    <Box className={styles.headerTop}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={handleBackClick}
        className={styles.backButton}
      >
        {backLabel}
      </Button>

      {isAuthenticated && (
        <IconButton
          onClick={() => toggleFavorite(entry.entryId)}
          className={styles.favoriteButton}
          sx={{
            color: favorites.has(entry.entryId)
              ? default_theme.palette.other.red
              : default_theme.palette.font.gray,
          }}
        >
          {favorites.has(entry.entryId) ? (
            <FavoriteIcon />
          ) : (
            <FavoriteBorderIcon />
          )}
        </IconButton>
      )}
    </Box>
  );
};

export default SolutionDetailActions;